import React from 'react';
import { connect } from 'react-redux'
import { Redirect } from 'react-router';

import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Link from '@material-ui/core/Link';
import Typography from "@material-ui/core/Typography";
import VisibilityIcon from '@material-ui/icons/VisibilityOutlined';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOffOutlined';

import Api from '../../../../../../common/api'
import Local from '../../../../../../common/local'
import StandardSelect from '../../../../shared/components/gn-standard-select';
import StandardInput from '../../../../shared/components/gn-standard-input';
import GnPhoneInput from '../../../../shared/components/gn-phone-input';
import withTranslations from '../../../../../../common/components/with-translations';

const styles = (theme) => ({
  view: {
    ...theme.internalContainer,
    [theme.breakpoints.up('md')]: {
      padding: theme.internalContainer._themeMdPadding
    },
  },
  button: {
    borderRadius: '9999px',
    fontWeight: '600',
    fontSize: '16px',
    height: '55px',
    width: '100%',
  },
  buttonHover: {
    '&:hover': {
      backgroundColor: 'var(--button-hover-color) !important'
    },
  },
  buttonControls: {
    display: "flex",
    justifyContent: "center",
    marginTop: "15px"
  },
  guestText: {
    fontSize: '14px',
    paddingTop: '20px',
    textAlign: 'center'
  },
  noHeaderContainer: {
    padding: '20px 20px 0px 20px',
    maxWidth: '1200px',
    margin: '0 auto 50px auto'
  },
  infoText: {
    fontSize: '12px',
    textAlign: 'center'
  },
  linkText: {
    color: '#222222',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  optInCheckBox: {
    display: 'inline'
  },
  optInContainer: {
    textAlign: 'center',
  },
  optInRow: {
    display: 'flex',
    alignItems: 'flex-start',
    textAlign: 'left'
  },
  optInText: {
    fontSize: '12px',
    textAlign: 'center'
  },
  signInText: {
    fontSize: '14px',
    paddingTop: '10px',
    textAlign: 'center'
  },
  stepTitle: {
    display: "flex",
    justifyContent: "center",
    fontWeight: '600',
    fontSize: '1.2rem',
    marginBottom: '10px',
  }
});

class StepCreateAccount extends React.Component {

  constructor(props) {

    super(props);

    // The application may already be loaded when this step mounts (e.g. flow started at CHECK_EMAIL),
    // in which case componentDidUpdate never sees the application arrive.
    const locale = (props.application && props.application.registration && props.application.registration.locale) || {};

    this.state = {
      countryCode: locale.defaultCountry || '',
      firstName: '',
      lastName: '',
      password: '',
      phoneNumber: '',
      phoneValid: false,
      preferredLanguage: locale.defaultLanguage || '1033',
      processing: false,
      showPassword: false,
      smsOptInSelected: false,
      username: props.username ? props.username : '',
      validation: {
        countryCode: null,
        firstName: null,
        lastName: null,
        password: null,
        phoneNumber: null,
        preferredLanguage: null,
        username: null,
      }
    };

    this.api = new Api();
    this.generateOnInput = this.generateOnInput.bind(this);
    this.goGuest = this.goGuest.bind(this);
    this.goSignIn = this.goSignIn.bind(this);
    this.goValidateEmail = this.goValidateEmail.bind(this);
    this.onCountryCodeChange = this.onCountryCodeChange.bind(this);
    this.onPreferredLanguageChange = this.onPreferredLanguageChange.bind(this);
    this.onShowPassword = this.onShowPassword.bind(this);
    this.onSmsOptInChange = this.onSmsOptInChange.bind(this);
    this.onPhoneNumberChange = this.onPhoneNumberChange.bind(this);
    this.onPhoneValidityChange = this.onPhoneValidityChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onSubmitPressed = this.onSubmitPressed.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.application && this.props.application && this.props.application.registration && this.props.application.registration.locale) {
      const locale = this.props.application.registration.locale;
      const updates = {};

      if (locale.defaultCountry) {
        updates.countryCode = locale.defaultCountry;
      }

      if (locale.defaultLanguage) {
        updates.preferredLanguage = locale.defaultLanguage;
      }

      if (Object.keys(updates).length > 0) {
        this.setState(updates);
      }
    }
  }

  generateOnInput(stateKey) {

    return function (e) {

      this.setState({
        [stateKey]: e.target.value,
        validation: { countryCode: null, firstName: null, lastName: null, password: null, phoneNumber: null, preferredLanguage: null, username: null, }
      });
    }.bind(this);
  }

  goGuest(e) {
    e.preventDefault();
    this.props.goGuest(this.state.username);
  }

  goSignIn(e) {
    e.preventDefault();
    this.props.goSignIn();
  }

  goValidateEmail(username) {
    this.props.goValidateEmail(username);
  }

  onCountryCodeChange(e) {
    this.setState({
      countryCode: e.target.value,
      validation: { countryCode: null, password: null, preferredLanguage: null, username: null, }
    });
  }

  onPreferredLanguageChange(e) {
    this.setState({
      preferredLanguage: e.target.value,
      validation: { countryCode: null, password: null, preferredLanguage: null, username: null, }
    });
  }

  onShowPassword() {
    this.setState({ showPassword: !this.state.showPassword });
  }

  onSmsOptInChange(e) {
    this.setState({
      smsOptInSelected: e.target.checked,
      validation: { ...this.state.validation, phoneNumber: null }
    });
  }

  onPhoneNumberChange(number) {
    this.setState({ phoneNumber: number });
  }

  onPhoneValidityChange(valid) {
    this.setState({ phoneValid: valid });
  }

  async onSubmitPressed(e) {

    if (e.key === 'Enter') {
      return this.onSubmit();
    }
  }

  async onSubmit() {
    const { t } = this.props;

    let localeCountryEnabled = false;
    let localeLanguageEnabled = false;
    let firstNameEnabled = false;
    let lastNameEnabled = false;
    let phoneNumberEnabled = false;
    let smsOptInEnabled = false;

    if (this.props.application) {
      if (this.props.application.registration !== undefined && this.props.application.registration.locale !== undefined) {
        localeCountryEnabled = this.props.application.registration.locale.countryEnabled === true;
        localeLanguageEnabled = this.props.application.registration.locale.languageEnabled === true;
      }
      if (this.props.application.registration !== undefined && this.props.application.registration.firstName !== undefined) {
        firstNameEnabled = this.props.application.registration.firstName.enabled === true;
      }
      if (this.props.application.registration !== undefined && this.props.application.registration.lastName !== undefined) {
        lastNameEnabled = this.props.application.registration.lastName.enabled === true;
      }
      if (this.props.application.registration !== undefined && this.props.application.registration.phoneNumber !== undefined) {
        phoneNumberEnabled = this.props.application.registration.phoneNumber.enabled === true;
      }
      if (this.props.application.registration !== undefined && this.props.application.registration.smsOptIn !== undefined) {
        smsOptInEnabled = this.props.application.registration.smsOptIn.enabled === true;
      }
    }

    const {
      countryCode,
      firstName,
      lastName,
      password,
      phoneNumber,
      phoneValid,
      preferredLanguage,
      username,
    } = this.state;

    const { smsOptInSelected } = this.state;
    const smsEnabled = smsOptInEnabled;
    const phoneRequired = phoneNumberEnabled || (smsEnabled && smsOptInSelected);

    const validation = {
      countryCode: localeCountryEnabled ? countryCode.length ? null : t('stepCreateAccount.countryRequiredError') : null,
      firstName: firstNameEnabled ? (firstName.length ? null : t('stepCreateAccount.firstNameRequiredError')) : null,
      lastName: lastNameEnabled ? (lastName.length ? null : t('stepCreateAccount.lastNameRequiredError')) : null,
      password: password.length ? null : t('stepCreateAccount.passwordRequiredError'),
      phoneNumber: phoneRequired
        ? (phoneNumber && phoneValid ? null : t('stepCreateAccount.phoneNumberRequiredError'))
        : null,
      preferredLanguage: localeLanguageEnabled ? preferredLanguage ? null : t('stepCreateAccount.preferredLanguageRequiredError') : null,
      username: username.length ? null : t('stepCreateAccount.usernameRequiredError'),
    };

    if (Object.values(validation).some((v) => { return v !== null; })) {
      return this.setState({ validation });
    }

    let payload = {
      username,
      password,
    };

    if (localeCountryEnabled) {
      payload.countryCode = countryCode;
    }

    if (localeLanguageEnabled) {
      payload.preferredLanguage = preferredLanguage;
    }

    if (firstNameEnabled) {
      payload.firstName = firstName;
    }

    if (lastNameEnabled) {
      payload.lastName = lastName;
    }

    if (phoneNumberEnabled || (smsEnabled && smsOptInSelected)) {
      payload.phoneNumber = phoneNumber;
    }

    this.setState({ processing: true });

    const that = this;

    try {
      const result = await this.api.post(`/user${this.props.query.client_id ? `?clientId=${this.props.query.client_id}` : ''}`, payload);

      if (result.code !== 200) {
        this.props.postMessageRaw({
          data: {
            message: result.content.message,
            statusCode: result.code
          },
          event: 'createAccount',
          success: false,
        });

        if (result.code === 412) {
          return this.setState({
            processing: false,
            validation: {
              username: (
                <span>
                  {t('stepCreateAccount.emailAlreadyRegisteredError', {
                    link: <Link onClick={this.goSignIn} to="/gn">{t('stepCreateAccount.loginInsteadLinkText')}</Link>
                  })}
                </span>
              ),
              password: this.state.validation.password ? this.state.validation.password.slice() : null,
            }
          });
        }
        else if (result.code === 400) {
          this.setState({ processing: false });
          return this.props.onError({
            error: function () {
              if ((result.content.validation &&
                result.content.validation.keys.length &&
                result.content.validation.keys[0] === 'username') ||
                (result.content && result.content.message === 'The email address is not valid.')
              ) {
                validation.username = t('stepCreateAccount.validEmailError');
                that.setState({ validation });
                return t('stepCreateAccount.invalidEmailError');
              }

              if (result.content.message) {
                return result.content.message;
              }
              return undefined;
            }() || t('stepCreateAccount.emailMistakeError')
          });
        }
        else if (result.code === 424) {
          this.setState({ processing: false });
          this.goValidateEmail(username);
          return;
        }
        else {
          this.setState({ processing: false });
          return this.props.onError({
            error: t('stepCreateAccount.genericError')
          });
        }
      }

      Local.userLogin(result.content.token, username);
      this.setState({ processing: false });

      const successPayload = { event: 'createAccount', success: true, email: username };
      const optInResult = !!(this.props.optIn && this.props.optInSelected);
      const smsOptInResult = !!(smsEnabled && smsOptInSelected && phoneValid && phoneNumber);

      if (optInResult) {
        successPayload.optIn = true;
      }

      if (smsOptInResult) {
        successPayload.smsOptIn = true;
        successPayload.phoneNumber = phoneNumber;
      }

      if (this.props.onAccountCreated) {
        this.props.onAccountCreated({
          optIn: optInResult,
          smsOptIn: smsOptInResult,
          phoneNumber: smsOptInResult ? phoneNumber : '',
        });
      }

      this.props.postMessageRaw(successPayload);
      return this.props.goAuthorize();
    }
    catch (e) {
      return this.props.onError({ error: e.toString() });
    }
  }

  redirect(redirect) {
    this.setState({ redirect });
  }

  render() {
    const { t } = this.props;
    const privacyPolicyUrl = window.globals && window.globals.gidLinkPrivacyPolicy ? window.globals.gidLinkPrivacyPolicy : 'https://www.golfnow.com/privacy-policy';
    const smsTermsAndConditionsUrl = window.globals?.gid?.links?.smsTermsAndConditions || '#';
    const termsAndConditionsUrl = window.globals && window.globals.gidLinkTermsAndConditions ? window.globals.gidLinkTermsAndConditions : 'https://www.golfnow.com/support/about-us/terms';


    const containerStyle =
      this.props.query.noHeader ?
        this.props.classes.noHeaderContainer :
        this.props.classes.view;

    let localeCountryEnabled = false;
    let localeLanguageEnabled = false;
    let firstNameEnabled = false;
    let lastNameEnabled = false;
    let phoneNumberEnabled = false;
    let smsOptInEnabled = false;

    if (this.props.application) {
      if (this.props.application.registration !== undefined && this.props.application.registration.locale !== undefined) {
        localeCountryEnabled = this.props.application.registration.locale.countryEnabled === true;
        localeLanguageEnabled = this.props.application.registration.locale.languageEnabled === true;
      }
      if (this.props.application.registration !== undefined && this.props.application.registration.firstName !== undefined) {
        firstNameEnabled = this.props.application.registration.firstName.enabled === true;
      }
      if (this.props.application.registration !== undefined && this.props.application.registration.lastName !== undefined) {
        lastNameEnabled = this.props.application.registration.lastName.enabled === true;
      }
      if (this.props.application.registration !== undefined && this.props.application.registration.phoneNumber !== undefined) {
        phoneNumberEnabled = this.props.application.registration.phoneNumber.enabled === true;
      }
      if (this.props.application.registration !== undefined && this.props.application.registration.smsOptIn !== undefined) {
        smsOptInEnabled = this.props.application.registration.smsOptIn.enabled === true;
      }
    }

    const endAdornment = this.state.showPassword ?
      <VisibilityOffIcon color="action" style={{ 'cursor': 'pointer' }} onClick={this.onShowPassword} /> :
      <VisibilityIcon color="action" style={{ 'cursor': 'pointer' }} onClick={this.onShowPassword} />;

    const endAdornmentWrapper = (
      <InputAdornment position="end">
        <IconButton
          aria-label="toggle password visibility"
          onClick={this.onShowPassword}
          edge="end"
        >
          {this.state.showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
        </IconButton>
      </InputAdornment>
    )

    const focusEmail = this.state.username ? false : true;
    const focusPassword = !focusEmail;

    const firstNameInput = !firstNameEnabled ? null : (
      <Grid item xs={12} md={12}>
        <StandardInput
          inputType="text"
          value={this.state.firstName}
          style={{ marginBottom: '15px' }}
          error={this.state.validation.firstName}
          attribute="firstName"
          label={t('stepCreateAccount.firstNameLabel')}
          labelWidth={80}
          onChange={this.generateOnInput('firstName')}
          onKeyUp={this.onSubmitPressed} />
      </Grid>
    );

    const lastNameInput = !lastNameEnabled ? null : (
      <Grid item xs={12} md={12}>
        <StandardInput
          inputType="text"
          value={this.state.lastName}
          style={{ marginBottom: '15px' }}
          error={this.state.validation.lastName}
          attribute="lastName"
          label={t('stepCreateAccount.lastNameLabel')}
          labelWidth={80}
          onChange={this.generateOnInput('lastName')}
          onKeyUp={this.onSubmitPressed} />
      </Grid>
    );

    const emailInput = (
      <Grid item xs={12} md={12}>
        <StandardInput
          inputType="email"
          value={this.state.username}
          style={{ marginBottom: '15px' }}
          error={this.state.validation.username}
          attribute="username"
          label={t('stepCreateAccount.emailLabel')}
          labelWidth={85}
          focus={focusEmail}
          onChange={this.generateOnInput('username')}
          onKeyUp={this.onSubmitPressed} />
      </Grid>
    );

    const passwordInput = (
      <Grid item xs={12} md={12}>
        <StandardInput
          inputType={this.state.showPassword ? 'text' : 'password'}
          style={{ marginBottom: '15px' }}
          error={this.state.validation.password}
          password={true}
          attribute="password"
          label={t('stepCreateAccount.passwordLabel')}
          labelWidth={112}
          focus={focusPassword}
          endAdornment={endAdornment}
          showPasswordRules={true}
          onChange={this.generateOnInput('password')}
          onKeyUp={this.onSubmitPressed} />
      </Grid>
    );

    const displayableContent = this.props.application && this.props.application.displayable && this.props.application.displayable.content
      ? this.props.application.displayable.content
      : {};

    const buttonColor = displayableContent.buttonColor || (this.props.query.buttonColor && `#${this.props.query.buttonColor}`);
    const buttonHoverColor = displayableContent.buttonHoverColor || (this.props.query.buttonHoverColor && `#${this.props.query.buttonHoverColor}`);

    const buttonStyle = {
      ...(buttonColor && { backgroundColor: buttonColor }),
      ...(buttonHoverColor && { '--button-hover-color': buttonHoverColor }),
    };

    const buttonClassName = buttonHoverColor ?
      `${this.props.classes.button} ${this.props.classes.buttonHover}` :
      this.props.classes.button;

    const bottomControls = (
      <Grid className={this.props.classes.buttonControls} item xs={12}>
        <Button style={buttonStyle} className={buttonClassName} color="primary" onClick={this.onSubmit} variant="contained" id="login">
          {this.state.processing ?
            (<CircularProgress size={14} color="inherit" />)
            : t('stepCreateAccount.createAccountButton')
          }
        </Button>
      </Grid>
    );

    const guestLink = (this.props.showGuestLink || this.props.guestCheckoutEnabled) ? (
      <Grid item xs={12} md={12}>
        <Typography className={this.props.classes.guestText} color="initial" >
          <Link className={this.props.classes.linkText} onClick={this.goGuest} to="/gn">{t('stepCreateAccount.guestLinkText')}</Link>
        </Typography>
      </Grid>
    ) : null;

    let optInLabel = null;

    if (this.props.optIn) {
      optInLabel = (
        <div
          dangerouslySetInnerHTML={{ __html: this.props.optInCopy }}
        />
      );
    }

    const optIn = !this.props.optIn ? null :
      (
        <Grid className={this.props.classes.optInContainer} item xs={12} md={12}>
          <div className={this.props.classes.optInRow}>
            <Checkbox className={this.props.classes.optInCheckBox} checked={this.props.optInSelected} color="primary" onChange={this.props.onOptIn} />
            {optInLabel}
          </div>
        </Grid>
      );

    const phoneOnlyCountries = (this.props.phoneCountries && this.props.phoneCountries.length)
      ? this.props.phoneCountries.map(c => c.id.toLowerCase())
      : [];

    const phoneInput = !(phoneNumberEnabled || smsOptInEnabled) ? null : (
      <Grid item xs={12} md={12}>
        <GnPhoneInput
          key={this.props.phoneCountries ? 'loaded' : 'loading'}
          error={this.state.validation.phoneNumber}
          onChangeNumber={this.onPhoneNumberChange}
          onChangeValidity={this.onPhoneValidityChange}
          onlyCountries={phoneOnlyCountries}
          placeholder={t('stepCreateAccount.phoneNumberLabel')}
          style={{ marginBottom: '15px' }}
          value={this.state.phoneNumber}
        />
      </Grid>
    );

    const smsOptInLabel = this.props.smsOptInCopy
      ? <div dangerouslySetInnerHTML={{ __html: this.props.smsOptInCopy }} />
      : (
        <p style={{ fontSize: '12px', textAlign: 'left', margin: 0 }}>
          {t('stepCreateAccount.smsOptInDefaultCopy', {
            termsLink: <a className={this.props.classes.linkText} rel="noopener noreferrer" target="_blank" href={smsTermsAndConditionsUrl}>{t('stepCreateAccount.smsTermsLinkText')}</a>,
            privacyLink: <a className={this.props.classes.linkText} rel="noopener noreferrer" target="_blank" href="https://www.golfnow.com/support/about-us/terms">{t('stepCreateAccount.smsPrivacyLinkText')}</a>
          })}
        </p>
      );

    const smsOptIn = !smsOptInEnabled ? null : (
      <Grid className={this.props.classes.optInContainer} item xs={12} md={12}>
        <div className={this.props.classes.optInRow}>
          <Checkbox
            className={this.props.classes.optInCheckBox}
            checked={this.state.smsOptInSelected}
            color="primary"
            onChange={this.onSmsOptInChange}
          />
          {smsOptInLabel}
        </div>
      </Grid>
    );

    const countrySelect = localeCountryEnabled ? (
      <Grid item xs={12} md={12}>
        <StandardSelect
          attribute="country"
          error={this.state.validation.countryCode}
          label={t('stepCreateAccount.countryLabel')}
          labelWidth={60}
          menuItems={this.props.locale ? this.props.locale.countries : []}
          style={{ marginBottom: '15px' }}
          value={this.state.countryCode}
          onChange={this.onCountryCodeChange}
        />
      </Grid>
    ) : null;

    const preferredLanguageSelect = localeLanguageEnabled ? (
      <Grid item xs={12} md={12}>
        <StandardSelect
          attribute="preferredLanguage"
          error={this.state.validation.preferredLanguage}
          label={t('stepCreateAccount.preferredLanguageLabel')}
          labelWidth={120}
          menuItems={this.props.locale ? this.props.locale.languages : []}
          style={{ marginBottom: '15px' }}
          value={this.state.preferredLanguage}
          onChange={this.onPreferredLanguageChange}
        />
      </Grid>
    ) : null;

    const stepTitle = this.props.query.showSteps === 'true' ? (
      <Grid className={this.props.classes.stepTitle} item xs={12}>
        <Typography className={this.props.classes.stepTitle}>
          {t('stepCreateAccount.stepTitle')}
        </Typography>
      </Grid>
    ) : null;

    return (
      <Grid container spacing={1} className={containerStyle} >
        {stepTitle}
        {firstNameInput}
        {lastNameInput}
        {emailInput}
        {passwordInput}
        {phoneNumberEnabled ? phoneInput : null}
        {countrySelect}
        {preferredLanguageSelect}
        {optIn}
        {smsOptIn}
        {this.state.smsOptInSelected && !phoneNumberEnabled ? phoneInput : null}
        <Grid item xs={12} md={12}>
          <Typography className={this.props.classes.infoText} color="initial" >
            {t('stepCreateAccount.agreeToTerms', {
              termsLink: <a className={this.props.classes.linkText} rel="noopener noreferrer" target="_blank" href={termsAndConditionsUrl}>{t('stepCreateAccount.termsLinkText')}</a>,
              privacyLink: <a className={this.props.classes.linkText} rel="noopener noreferrer" target="_blank" href={privacyPolicyUrl}>{t('stepCreateAccount.privacyLinkText')}</a>
            })}
          </Typography>
        </Grid>
        {bottomControls}
        {guestLink}
        <Grid item xs={12} md={12}>
          <Typography className={this.props.classes.signInText} color="initial" >
            {t('stepCreateAccount.signInQuestion', {
              link: <Link className={this.props.classes.linkText} onClick={this.goSignIn} to="/gn">{t('stepCreateAccount.signInLinkText')}</Link>
            })}
          </Typography>
        </Grid>
      </Grid>
    );
  }
}

const mapStateToProps = state => {
  return {
  };
}

const ConnectedStepCreateAccount = connect(mapStateToProps, null)(StepCreateAccount);

export default withTranslations(withStyles(styles)(ConnectedStepCreateAccount));
